/* eslint-disable @typescript-eslint/no-unused-vars */
export const CASINO_SETTINGS = '/casino-settings';
export const CASINO_SETTINGS_GAMES = `${CASINO_SETTINGS}/games`;
export const CASINO_SETTINGS_LOGO = `${CASINO_SETTINGS}/logo`;
export const CASINO_SETTINGS_TEMPLATE = `${CASINO_SETTINGS}/template`;

export const CASINO_DEPOSIT_BONUS_PAGES = '/casino/deposit-bonus-pages';
export const CASINO_DEPOSIT_BONUS_PAGES_SHOW = `${CASINO_DEPOSIT_BONUS_PAGES}/show/:id`;
export const CASINO_DEPOSIT_BONUS_PAGES_EDIT = `${CASINO_DEPOSIT_BONUS_PAGES}/:id/edit`;
export const CASINO_DEPOSIT_BONUS_PAGES_CREATE = `${CASINO_DEPOSIT_BONUS_PAGES}/create`;

export const CASINO_DEPOSIT_BONUSES = '/casino/deposit-bonuses';
export const CASINO_DEPOSIT_BONUS_SHOW = `${CASINO_DEPOSIT_BONUSES}/show/:id`;
export const CASINO_DEPOSIT_BONUS_CREATE = `${CASINO_DEPOSIT_BONUSES}/create`;

export const CASINO_FREESPIN_CAMPAIGNS = '/freespin-campaigns';
export const CASINO_FREESPIN_CAMPAIGN_SHOW = `${CASINO_FREESPIN_CAMPAIGNS}/show/:id`;
export const CASINO_FREESPIN_CAMPAIGN_CREATE = `${CASINO_FREESPIN_CAMPAIGNS}/create`;

export const CASINO_DASHBOARD = '/casino';
export const CASINO_SLIDERS = '/casino-sliders';

export const CASINO_TRANSACTIONS = '/casino-transactions';
export const CASINO_TRANSACTIONS_BETS = '/casino-transactions/bet/:id';

export const CASINO_GAME_CATEGORY = '/game-categories';
export const CASINO_GAME_CATEGORY_SHOW = `${CASINO_GAME_CATEGORY}/show/:id`;
export const CASINO_GAME_CATEGORY_EDIT = `${CASINO_GAME_CATEGORY}/:id/edit`;
export const CASINO_GAME_CATEGORY_CREATE = `${CASINO_GAME_CATEGORY}/create`;

export const CASINO_GAME_CREATORS = '/game-creators';
export const CASINO_GAME_CREATORS_SHOW = `${CASINO_GAME_CREATORS}/show/:id`;
export const CASINO_GAME_CREATORS_EDIT = `${CASINO_GAME_CREATORS}/edit/:id`;
export const CASINO_GAME_CREATORS_GAME_EDIT = `${CASINO_GAME_CREATORS}/show/:gameCreatorId/edit/:gameId`;

export const CASINO_GAME_CREATORS_SEO = `${CASINO_GAME_CREATORS}/seo`;
export const CASINO_GAME_CREATORS_SEO_SHOW = `${CASINO_GAME_CREATORS_SEO}/show/:id`;
export const CASINO_GAME_CREATORS_SEO_EDIT = `${CASINO_GAME_CREATORS_SEO}/edit/:id`;
export const CASINO_GAME_CREATORS_SEO_CREATE = `${CASINO_GAME_CREATORS_SEO}/create/:id`;

export const CASINO_TOURNAMENTS = '/tournaments';
export const CASINO_TOURNAMENTS_SHOW = `${CASINO_TOURNAMENTS}/show/:id`;
export const CASINO_TOURNAMENTS_EDIT = `${CASINO_TOURNAMENTS}/:id/edit`;
export const CASINO_TOURNAMENTS_EDIT_GAMES = `${CASINO_TOURNAMENTS}/:id/edit/games`;
export const CASINO_TOURNAMENTS_CREATE = `${CASINO_TOURNAMENTS}/create`;

export const CASINO_GAME_GGR_REPORT = '/reports/ggr/game';
export const CASINO_GAME_CREATOR_GGR_REPORT = '/reports/ggr/game-creator';

export const CASINO_GAME_CATEGORY_BLOCKS = '/game-category-blocks';
export const CASINO_GAME_CATEGORY_BLOCKS_EDIT = `${CASINO_GAME_CATEGORY_BLOCKS}/:id/edit`;
export const CASINO_GAME_CATEGORY_BLOCKS_CREATE = `${CASINO_GAME_CATEGORY_BLOCKS}/create`;
export const CASINO_GAME_CATEGORY_BLOCKS_DELETE = `${CASINO_GAME_CATEGORY_BLOCKS}/:id/delete`;

export const CASINO_FREESPIN_PAGES = '/freespin-pages';
export const CASINO_FREESPIN_PAGES_SHOW = `${CASINO_FREESPIN_PAGES}/show/:id`;
export const CASINO_FREESPIN_PAGES_EDIT = `${CASINO_FREESPIN_PAGES}/:id/edit`;
export const CASINO_FREESPIN_PAGES_CREATE = `${CASINO_FREESPIN_PAGES}/create`;

export const CASINO_NEWS_GAMES_WIDGET = '/casino-news-games-widget';

export const getAbsoluteCrmUrl = (path: string) => {
    const currentURL = window.location.href;
    const url = new URL(currentURL);

    const pathnameChunks = url.pathname.match(/[^/]+/g);
    const firstTwoChunks = pathnameChunks.slice(0, 2).join('/');

    return `${document.location.origin}/${firstTwoChunks}${path}`;
};
